<template>
    <div class="bg-slate-100 flex justify-center items-center h-screen">
        <Card class="w-80">
            <template #title>
                <div class="w-full text-textDarkGrey text-xl font-bold flex flex-row flex-1 gap-4 justify-center items-center mb-2">
                    <img src="@/assets/images/meetspain.svg" class="w-[100px]" />
                </div>
            </template>
            <template #content>
                <div class="flex flex-col gap-4 w-full">
                    <Input
                        :label="'El. paštas'"
                        placeholder=""
                        @update:modelValue="(newValue) => (email = newValue)">
                    </Input>
                    <InputPassword
                        :label="'Slaptažodis'"
                        @update:modelValue="(newValue) => (password = newValue)">
                    </InputPassword>

                    <Button label="Prisijungti" @click="login" :loading="loading" />
                </div>
            </template>
        </Card>
    </div>
</template>

<script setup lang="ts">
    // Imports
    import { ref, onMounted } from 'vue';
    import { useRouter } from 'vue-router'
    import { apiRequest } from '@/services/axios.ts'
    import { reloadRolesAndPermissions } from '@/extensions/permissions.ts'

    import Card from 'primevue/card';
    import Button from '@/components/buttons/Button.vue';
    import Input from '@/components/inputs/Input.vue';
    import InputPassword from '@/components/inputs/InputPassword.vue';

    import { Auth } from '@/stores/auth.ts';

    // Refs and variables
    const email = ref<string>('');
    const password = ref<string | undefined>('');
    const loading = ref(false);
    const auth = Auth();

    // Get current route info
    const router = useRouter()
    let currentPathObject: any = router.currentRoute.value;

    // Hooks
    onMounted(() => {
        isLoggedIn();
    });

    // Methods
    async function login()
    {
        loading.value = true

        try {
            const response = await apiRequest(
                'post',
                '/auth/login',
                {
                    email: email.value,
                    password: password.value
                }
            );

            localStorage.removeItem('authToken');
            localStorage.setItem('authToken', response.data.data.token);

            auth.isAuthenticated = true;
            auth.userData = response.data.data.data;

            // get user roles
            await reloadRolesAndPermissions();

            router.push({ path: '/contacts' });

        } catch {
            loading.value = false;
        }
    }

    function isLoggedIn()
    {
        if (auth.isAuthenticated) {
            router.push({ path: '/contacts' });
        }
    }
</script>